'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'face-hushed';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e37b';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm78.7-77.3c26.1-29.1 63.2-48.2 104.9-50.4 4.4-.2 8.2 3.1 8.4 7.6s-3.1 8.2-7.6 8.4c-37.2 2-70.5 19-93.8 45.1-2.9 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3zM192 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM320 384a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm-8-248.5c.3-4.4 4.1-7.8 8.5-7.5 36.7 2.3 69.6 18.6 93.3 43.7 3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3c-21.1-22.2-50.2-36.7-82.7-38.7-4.4-.3-7.8-4.1-7.5-8.5zM352 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M496 256a240 240 0 1 0 -480 0 240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-.5-112c-4.4-.3-7.8-4.1-7.5-8.5s4.1-7.8 8.5-7.5c36.7 2.3 69.6 18.6 93.3 43.7 3 3.2 2.9 8.3-.3 11.3s-8.3 2.9-11.3-.3C381.1 160.5 352 146 319.5 144zM208 135.8c.2 4.4-3.1 8.2-7.6 8.4-37.2 2-70.5 19-93.8 45.1-2.9 3.3-8 3.6-11.3 .6s-3.6-8-.6-11.3c26.1-29.1 63.2-48.2 104.9-50.4 4.4-.2 8.2 3.1 8.4 7.6zM304 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceHushed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;